import { DateSearch } from "../../../../common/commonViews.index";
export default function AdminLogsTableHeaderConstructor(dateSearchProps) {
  return {
    title: "Logs",
    firstRowChildren: () => <DateSearch {...dateSearchProps} />,
  };
}
